/**
 * Comment validation limits — the single source of truth shared by the
 * API (request/response TypeBox schemas + the per-expense count guard)
 * and the web/mobile composers (client-side `maxLength` + the live
 * character counter).
 *
 * Keeping the numbers here means the client can never let a user type
 * something the server would reject: lowering `MAX_LENGTH` tightens the
 * input cap and the API validation in one place.
 */
export const COMMENT_LIMITS = {
  /** Minimum characters in a comment body (rejects empty / whitespace-only). */
  MIN_LENGTH: 1,
  /** Maximum characters in a single comment body. */
  MAX_LENGTH: 250,
  /** Maximum number of comments (including replies) per expense. */
  MAX_PER_EXPENSE: 100,
} as const;
